module.exports = __webpack_public_path__ + "static/assets/1375866d6d0e919b11c92f8890f10ae9.png";